import {footerMap} from '@dazn/lp-web/src/constants/footer.constants';
import {elementClickEventTypes} from '@dazn/lp-web/src/analytics/fe-events/elementClick';
import {IFooterLinks} from '@dazn/lp-web/src/types/footer.types';
import {triggerElementClick} from '@dazn/lp-web/src/analytics/fe-events/index';

export const footerProxy = (component: any): IFooterLinks => {
    const componentType = component.fields.componentType;

    const footerKeys = component.fields.footerKeys;
    const footerResourceLinks = window.dazn.resourceStringsData.Links;

    const footerLinks = footerKeys
        .map((key: string) => {
            const footerLink = footerMap[key];
            const url = footerResourceLinks.find(
                (link) => link.Key === key
            )?.Value;

            if (!footerLink) {
                return null;
            }

            return {
                value: footerLink?.stringKey,
                url,
                action: () => {
                    if (url) {
                        triggerElementClick({
                            section: elementClickEventTypes.FOOTER,
                            itemId: footerLink?.stringKey || '',
                            resourceString: footerLink?.stringKey
                        });
                    }
                }
            };
        })
        ?.filter(Boolean);

    return {
        componentType,
        footerLinks
    };
};
